export const UMBRACO_CONSTANTS = {
    TERMS_URL:
        'https://netwealthnorth.blob.core.windows.net/public/terms/Netwealth%20General%20Terms%20and%20Conditions.pdf',
    PRIVACY_POLICY_URL:
        'https://netwealthnorth.blob.core.windows.net/public/terms/Netwealth%20Privacy%20Policy.pdf'
};
